/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "../Common/Fader/FormFader";
import wizardStyle from "../wizardStyle";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import TimeUnderIcon from "../../../assets/icons/traffic/toggleable/IconTimeLessThanOneSecond";
import TimeOverIcon from "../../../assets/icons/traffic/toggleable/IconTimeMoreThanOneSecond";
import QuestionIcon from "../../../assets/icons/common/toggleable/IconQuestionmark";
import { useForm } from "../../../provider/Form/FormProvider";
import Group from "../../Wizard/Group";
import { requiredValidator } from "../../../services/validationRules";
import Typography from "@mui/material/Typography";
import { translate } from "../../../services/translations/translations";
import FormSubmitProps from "../../../types/FormSubmitProps";
import { FormDataTypes } from "../../../types/FormDataTypes";
import { Box } from "@mui/material";

export default function RedLight({ submitProps }: { submitProps: FormSubmitProps }) {
  const { handleSubmit, values }: FormDataTypes = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Verstoß
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid size={12}>
              <Group
                type="radio"
                name="redLight"
                question={translate("traffic.redLight.label", values)}
                options={[
                  {
                    labelText: translate("traffic.redLight.options.under_1_sec.label", values),
                    labelIcon: <TimeUnderIcon />,
                    labelIconActive: <TimeUnderIcon active />,
                    value: "under_1_sec",
                  },
                  {
                    labelText: translate("traffic.redLight.options.1_sec_or_more.label", values),
                    labelIcon: <TimeOverIcon />,
                    labelIconActive: <TimeOverIcon active />,
                    value: "1_sec_or_more",
                  },
                  {
                    labelText: translate("traffic.redLight.options.unknown.label", values),
                    labelIcon: <QuestionIcon />,
                    labelIconActive: <QuestionIcon active />,
                    value: "unknown",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
